import {StyleSheet} from 'react-native';
import Colors from './Shared/Colors';

const ImpersonateStyleSheet = StyleSheet.create({
  header: {
    fontFamily: 'Poppins',
    fontSize: 20,
    fontWeight: '700',
    letterSpacing: 1.87,
    textTransform: 'uppercase',
    color: 'white',
  },
  container: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: Colors.darkestGreen,
    paddingVertical: 40,
  },
  form: {
    backgroundColor: Colors.yellow,
    flexDirection: 'column',
    borderRadius: 20,
    padding: 20,
    width: '50%',
  },
  label: {
    color: Colors.darkGreen,
    fontFamily: 'Poppins',
    fontSize: 11,
    fontWeight: '700',
    letterSpacing: 1.87,
    textTransform: 'uppercase',
  },
  input: {
    color: Colors.darkGreen,
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: '400',
    lineHeight: 14,
    letterSpacing: 0.07,
    backgroundColor: Colors.darkGreenTransparent,
    borderRadius: 6,
    padding: 12,
    paddingTop: 8,
    marginTop: 6,
    outlineStyle: 'none',
  },
  roleContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: 12,
    marginVertical: 6,
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.green,
    marginRight: 1,
    padding: 20,
    fontSize: 18,
    fontFamily: 'Lato',
    height: 10,
  },
});

export {ImpersonateStyleSheet};
